import React from 'react';
import { firmInfo } from '../mockData';

const LogoImage = ({ height = '50px', className = '', forFooter = false }) => {
  // Text-based logo that blends perfectly with background
  const textLogo = (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        lineHeight: 1.2
      }}
    >
      <div
        style={{
          fontFamily: 'Georgia, serif',
          fontSize: height === '60px' ? '1.5rem' : '1.25rem',
          fontWeight: '700',
          color: forFooter ? 'var(--accent-gold-light)' : 'var(--text-primary)',
          letterSpacing: '0.02em',
          textShadow: forFooter ? '0 2px 8px rgba(212, 175, 55, 0.3)' : 'none'
        }}
      >
        D J GOVINDARAJU
      </div>
      <div
        style={{
          fontFamily: 'Georgia, serif',
          fontSize: height === '60px' ? '0.875rem' : '0.75rem',
          fontWeight: '400',
          color: forFooter ? 'rgba(245, 239, 231, 0.9)' : 'var(--text-secondary)',
          letterSpacing: '0.15em',
          marginTop: '0.125rem',
          borderTop: forFooter ? '1px solid var(--accent-gold)' : '1px solid var(--border-primary)',
          paddingTop: '0.25rem'
        }}
      >
        AND ASSOCIATES
      </div>
    </div>
  );

  return textLogo;
};

export default LogoImage;
